import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex flex-column gap-3 p-2 p-lg-0" }

import { ComputedRef, computed } from 'vue'

  // Types
  import { BookingSummary } from '@/services/BookingService.interface'

  // Components
  import SlidingPanel from '@/components/UI/SlidingPanel.vue'
  import TravellersList from './TravellersList.vue'
  import PanelIntro from './TravellersPanelIntro.vue'

  // Config
  import { ModalId } from '@/config/modalIds'

  // Store
  import { useStore } from '@/store'
  import { useI18n } from 'vue-i18n'
  
export default /*@__PURE__*/_defineComponent({
  __name: 'TravellersPanel',
  setup(__props) {

  // Vue
  const store = useStore()

  // Translations
  const { t } = useI18n()

  // Methods
  const onClose = (): void => {
    store.commit('modal/close', ModalId.TRAVELLER_PANEL)
  }

  // Computed
  const isPanelOpen: ComputedRef<boolean> = computed(() => {
    const checkIsOpen = store.getters['modal/isOpen']
    return checkIsOpen(ModalId.TRAVELLER_PANEL)
  })

  // Get the selected booking from the Vuex store
  const selectedBooking: ComputedRef<BookingSummary | null> = computed(
    () => store.getters['booking/selectedBooking']
  )

  const loading: ComputedRef<boolean> = computed(() =>
    store.getters['booking/isLoading']('updateTraveller')
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SlidingPanel, {
    isPanelVisible: isPanelOpen.value,
    onClose: onClose,
    "on-confirm": onClose,
    "close-title": _unref(t)('travellers.title'),
    "display-confirm-button": true,
    "is-loading": loading.value,
    "has-overlay": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createVNode(PanelIntro),
        (selectedBooking.value)
          ? (_openBlock(), _createBlock(TravellersList, {
              key: 0,
              travellers: selectedBooking.value.travellers,
              "departure-date": selectedBooking.value.departureDate,
              "panel-mode": true
            }, null, 8, ["travellers", "departure-date"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["isPanelVisible", "close-title", "is-loading"]))
}
}

})